
import React from 'react';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import WhatIsDomotics from '@/components/WhatIsDomotics';
import HomeSeerSection from '@/components/HomeSeerSection';
import ServicesSection from '@/components/ServicesSection';
import AutomationCategories from '@/components/AutomationCategories';
import CompetitorCalculator from '@/components/CompetitorCalculator';
import ProjectPortfolio from '@/components/ProjectPortfolio';
import Testimonials from '@/components/Testimonials';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import HomeAutomationSimulator from '@/components/HomeAutomationSimulator';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white" data-id="mmgn04sj2" data-path="src/pages/HomePage.tsx">
      <Header data-id="7rnaymn4f" data-path="src/pages/HomePage.tsx" />
      <HeroSection data-id="464hqzuk1" data-path="src/pages/HomePage.tsx" />
      <WhatIsDomotics data-id="0bhj80uup" data-path="src/pages/HomePage.tsx" />
      <HomeSeerSection data-id="ukfc2um4z" data-path="src/pages/HomePage.tsx" />
      <ServicesSection data-id="rti9yfcfm" data-path="src/pages/HomePage.tsx" />
      <AutomationCategories data-id="mhqnbml21" data-path="src/pages/HomePage.tsx" />
      <CompetitorCalculator data-id="8uj7hktvm" data-path="src/pages/HomePage.tsx" />
      <section className="py-20 bg-gradient-to-br from-blue-50 to-purple-50" data-id="mu0zl0bw1" data-path="src/pages/HomePage.tsx">
        <div className="container mx-auto px-4" data-id="1k09dw0tw" data-path="src/pages/HomePage.tsx">
          <HomeAutomationSimulator data-id="u05admeob" data-path="src/pages/HomePage.tsx" />
        </div>
      </section>
      <ProjectPortfolio data-id="fop5z4ag6" data-path="src/pages/HomePage.tsx" />
      <Testimonials data-id="jgndlhvyw" data-path="src/pages/HomePage.tsx" />
      <ContactSection data-id="nmjqj4prd" data-path="src/pages/HomePage.tsx" />
      <Footer data-id="fc4p4kgq2" data-path="src/pages/HomePage.tsx" />
    </div>);

};

export default HomePage;